var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('person-bio-cell');
import { breakpoints, theme } from '@shapeable/theme';
import { ContentNode } from './content-node';
import { EntityBubbleImage } from './entity-bubble-image';
import { useEntity } from '../../hooks/use-entity';
import { useLang } from '../../hooks/use-lang';
import { useLink } from '../../hooks/use-link';
import { DottedChevronRightSmallIcon } from '../elements/dotted-chevron-right-small-icon';
import { LinkedinFilledCircleIcon } from '../elements/linkedin-filled-circle-icon';
import { startCase } from 'lodash';
import { useTooltipEffect } from '../../hooks/use-tooltip-effect';
import { TwitterFilledCircleIcon } from '../elements/twitter-filled-circle-icon';
import { WebFilledCircleIcon } from '../elements/web-filled-circle-icon';
export var PersonBioCellDefaultProps = {
  showOrganisation: false,
  useTooltip: true
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    ", "\n  "], ["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    ", "\n  "])), function (_a) {
    var isClickable = _a.isClickable;
    return isClickable && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      &:hover {\n        filter: brightness(1.05);\n      }\n    "], ["\n      &:hover {\n        filter: brightness(1.05);\n      }\n    "])));
  })
});
var PhotoStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
var NameStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    color: inherit;\n    font-size: 1em;\n    line-height: 1.1em;\n    margin: ", " 0 0;\n  "], ["\n    color: inherit;\n    font-size: 1em;\n    line-height: 1.1em;\n    margin: ", " 0 0;\n  "])), theme.UNIT(4))
});
var IconStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", ";\n    height: 24px;\n    width: 24px;\n    margin-right: ", ";\n  "], ["\n    ", ";\n    height: 24px;\n    width: 24px;\n    margin-right: ", ";\n  "])), theme.FILL(cls.color(), 'secondary'), theme.UNIT(2))
});
var ButtonStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    text-transform: uppercase;\n    display: flex;\n    cursor: pointer;\n    text-decoration: none;\n    align-items: center;\n    border: 1.5px dotted ", ";\n    border-radius: 20px;\n    padding: ", " ", ";\n    font-size: ", ";\n    height: 21px;\n    ", ";\n    color: ", ";\n  "], ["\n    text-transform: uppercase;\n    display: flex;\n    cursor: pointer;\n    text-decoration: none;\n    align-items: center;\n    border: 1.5px dotted ", ";\n    border-radius: 20px;\n    padding: ", " ", ";\n    font-size: ", ";\n    height: 21px;\n    ", ";\n    color: ", ";\n  "])), theme.COLOR(cls.color(), 'secondary'), theme.UNIT(0), theme.UNIT(4), theme.FONT_SIZE(13), theme.FILL(cls.color(), 'secondary'), theme.COLOR(cls.color(), 'secondary'))
});
var ButtonIconStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    width: 7px;\n    margin-left: ", ";\n  "], ["\n    width: 7px;\n    margin-left: ", ";\n  "])), theme.UNIT(2))
});
var BodyStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    ", "\n  "], ["\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    ", "\n  "])), function (_a) {
    var isClickable = _a.isClickable;
    return isClickable && css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      cursor: pointer;\n    "], ["\n      cursor: pointer;\n    "])));
  })
});
var PositionStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    font-weight: 300;\n    color: ", ";\n    margin-top: ", ";\n  "], ["\n    font-weight: 300;\n    color: ", ";\n    margin-top: ", ";\n  "])), theme.COLOR('text'), theme.UNIT(1))
});
var FooterStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    margin-top: ", ";\n  "], ["\n    display: flex;\n    flex-direction: row;\n    margin-top: ", ";\n  "])), theme.UNIT(2))
});
var BioStyles = breakpoints({
  base: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var OrganisationStyles = breakpoints({
  base: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    margin-top: ", ";\n    text-transform: capitalize;\n  "], ["\n    margin-top: ", ";\n    text-transform: capitalize;\n  "])), theme.UNIT(1))
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled.div.attrs(cls.attr('body'))(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Photo: styled(EntityBubbleImage)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), PhotoStyles),
  Name: styled.h1.attrs(cls.attr('name'))(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), NameStyles),
  Bio: styled(ContentNode)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), BioStyles),
  Position: styled.span.attrs(cls.attr('position'))(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), PositionStyles),
  Organisation: styled.span.attrs(cls.attr('organisation'))(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), OrganisationStyles),
  Footer: styled.div.attrs(cls.attr('footer'))(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), FooterStyles),
  LinkedinIcon: styled(LinkedinFilledCircleIcon)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  TwitterIcon: styled(TwitterFilledCircleIcon)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  WebIcon: styled(WebFilledCircleIcon)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  WebsiteButton: styled.a.attrs(cls.attr('website-button'))(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), ButtonStyles),
  Button: styled.span.attrs(cls.attr('button'))(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), ButtonStyles),
  ButtonIcon: styled(DottedChevronRightSmallIcon)(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), ButtonIconStyles)
};
export var PersonBioCell = function PersonBioCell(props) {
  var className = props.className,
      children = props.children,
      showOrganisation = props.showOrganisation,
      useTooltip = props.useTooltip,
      transform = props.transform;
  var entity = useEntity(props.entity);
  var linkedin = entity.linkedin,
      twitter = entity.twitter,
      slug = entity.slug,
      websiteUrl = entity.websiteUrl,
      name = entity.name,
      position = entity.position,
      bio = entity.bio,
      organisation = entity.organisation;
  var Link = useLink().Link;
  var t = useLang();
  useTooltipEffect();
  var hasOrganisation = showOrganisation && !!organisation && organisation.name;
  var hasWebsite = !!websiteUrl;
  var hasBio = !!(bio && bio.html);
  var isClickable = hasWebsite || hasBio;
  var hasFooter = hasBio || hasWebsite || linkedin || twitter;
  var onClick = !!((!hasBio || !useTooltip) && hasWebsite) ? function () {
    window.open(websiteUrl);
  } : function () {};
  var tooltipProps = useTooltip && hasBio ? {
    "data-event": "click",
    "data-tip": bio && bio.html || '',
    "data-html": true
  } : {};

  var swallowEvent = function swallowEvent(event) {
    event.stopPropagation();
  };

  return React.createElement(My.Container, {
    onClick: onClick,
    isClickable: isClickable,
    className: cls.name(className)
  }, React.createElement(My.Body, __assign({
    isClickable: isClickable
  }, tooltipProps), React.createElement(My.Photo, {
    transform: transform,
    size: 112,
    entity: entity
  }), React.createElement(My.Name, null, name), position && React.createElement(My.Position, null, startCase(position.toLowerCase())), hasOrganisation && React.createElement(My.Organisation, null, startCase(organisation.name.toLowerCase())), hasFooter && React.createElement(My.Footer, null, twitter && React.createElement(Link, {
    onClick: swallowEvent,
    title: t('Twitter'),
    href: twitter,
    target: "_blank"
  }, React.createElement(My.TwitterIcon, null)), linkedin && React.createElement(Link, {
    onClick: swallowEvent,
    title: t('Linkedin'),
    href: linkedin,
    target: "_blank"
  }, React.createElement(My.LinkedinIcon, null)), hasWebsite && React.createElement(Link, {
    onClick: swallowEvent,
    title: t('Website'),
    href: websiteUrl,
    target: "_blank"
  }, React.createElement(My.WebIcon, null)), hasBio && React.createElement(My.Button, null, t('Bio'), React.createElement(My.ButtonIcon, null)))));
};
PersonBioCell.defaultProps = PersonBioCellDefaultProps;
PersonBioCell.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27;